// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonWithTransparentBackground_button__1hz3u"};